module.exports = __webpack_public_path__ + "static/media/vdo-benefit.abeaa387.png";